export const skills = [
  {
    icon: '🤖',
    title: "Machine Learning & Détection d'Anomalies",
    color: 'accent',
    tags: [
      { label: 'Isolation Forest', color: 'accent' },
      { label: 'XGBoost', color: 'accent' },
      { label: 'BERT', color: 'accent' },
      { label: 'Classification', color: 'accent' },
      { label: 'FAISS', color: '' },
      { label: 'Model Evaluation', color: '' },
      { label: 'Feature Engineering', color: '' },
    ],
  },
  {
    icon: '📊',
    title: 'Data Engineering & Capteurs',
    color: 'red',
    tags: [
      { label: 'Pandas / NumPy', color: 'red' },
      { label: 'Preprocessing Pipelines', color: 'red' },
      { label: 'Time-Series', color: 'red' },
      { label: 'Sensor Data', color: '' },
      { label: 'EDA', color: '' },
      { label: 'PostgreSQL', color: '' },
      { label: 'Oracle SQL', color: '' },
    ],
  },
  {
    icon: '⚙️',
    title: 'Backend & APIs Temps Réel',
    color: 'green',
    tags: [
      { label: 'Django REST', color: 'green' },
      { label: 'FastAPI', color: 'green' },
      { label: 'Spring Boot', color: 'green' },
      { label: 'WebSocket', color: '' },
      { label: 'REST APIs', color: '' },
      { label: 'Microservices', color: '' },
    ],
  },
  {
    icon: '🖥️',
    title: 'Dashboard & Visualisation',
    color: 'accent',
    tags: [
      { label: 'React', color: 'accent' },
      { label: 'Real-time Dashboard', color: 'accent' },
      { label: 'Data Viz', color: '' },
      { label: 'Alerting Systems', color: '' },
      { label: 'Monitoring UI', color: '' },
    ],
  },
  {
    icon: '🐍',
    title: 'Langages',
    color: '',
    tags: [
      { label: 'Python', color: 'accent' },
      { label: 'Java (OCP 17)', color: '' },
      { label: 'C / C++', color: '' },
      { label: 'JavaScript', color: '' },
    ],
  },
  {
    icon: '🛠️',
    title: 'Outils & DevOps',
    color: '',
    tags: [
      { label: 'Git / GitHub', color: '' },
      { label: 'Linux (Ubuntu)', color: '' },
      { label: 'Postman', color: '' },
      { label: 'VisualVM', color: '' },
      { label: 'JMH', color: '' },
      { label: 'Scrum', color: '' },
    ],
  },
];

export const projects = [
  {
    num: '01',
    category: '⭐ Projet Phare — Sujet 1',
    title: 'Machine Failure Detection',
    desc: "Système de détection précoce des pannes machines à partir de données capteurs industriels. Pipeline de prétraitement complet, modèle supervisé de classification d'état, backend Django et dashboard React pour monitoring en temps réel.",
    tags: [
      { label: 'Python', color: 'red' },
      { label: 'Machine Learning', color: 'red' },
      { label: 'Django', color: '' },
      { label: 'React', color: '' },
      { label: 'PostgreSQL', color: '' },
      { label: 'Sensor Data', color: '' },
    ],
    link: 'https://github.com/chaimae098/Machine_failure_detection',
    featured: true,
  },
  {
    num: '02',
    category: 'IA & NLP',
    title: "IncidAI – Classification Intelligente d'Incidents",
    desc: "Système IA pour classifier automatiquement les tickets IT et recommander des résolutions. XGBoost + embeddings sémantiques BERT, backend Django REST + microservice FastAPI pour l'inférence ML, recherche sémantique FAISS.",
    tags: [
      { label: 'XGBoost', color: 'accent' },
      { label: 'BERT', color: 'accent' },
      { label: 'FAISS', color: 'accent' },
      { label: 'FastAPI', color: '' },
      { label: 'Django', color: '' },
      { label: 'React', color: '' },
    ],
    link: 'https://github.com/AgorAI-Hackathon/IncidAI',
    featured: false,
  },
  {
    num: '03',
    category: 'Monitoring & Anomalie',
    title: 'prmon Anomaly Detection',
    desc: "Détection d'anomalies sur les métriques de monitoring de processus (prmon). Analyse de séries temporelles, identification de comportements anormaux dans les données de performance système — compétence directement applicable au monitoring industriel temps réel.",
    tags: [
      { label: 'Python', color: 'accent' },
      { label: 'Time Series', color: 'accent' },
      { label: 'Anomaly Detection', color: 'accent' },
      { label: 'Process Monitoring', color: '' },
      { label: 'Data Analysis', color: '' },
    ],
    link: 'https://github.com/chaimae098/prmon-anomaly-detection',
    featured: false,
  },
  {
    num: '04',
    category: 'Performance JVM',
    title: 'JVM Performance Analysis',
    desc: 'Analyse de performance des applications Java sous charges réelles. Microbenchmarks JMH, profilage JVM warm-up, JIT et garbage collection via VisualVM et GraalVM.',
    tags: [
      { label: 'Java', color: '' },
      { label: 'GraalVM', color: '' },
      { label: 'JMH', color: '' },
      { label: 'VisualVM', color: '' },
      { label: 'Performance', color: '' },
    ],
    link: null,
    featured: false,
  },
];

export const experience = [
  {
    date: 'Jan – Fév 2026',
    title: 'Web Development Intern',
    company: 'S B Solutions — Casablanca',
    bullets: [
      'Développement d\'une plateforme connectant clients et prestataires locaux',
      'Implémentation frontend React + backend Spring Boot',
      'Participation aux code reviews et planification de sprint',
    ],
  },
  {
    date: 'Jun – Août 2025',
    title: 'IT Intern',
    company: 'Fiscinfo — Casablanca',
    bullets: [
      'Analyse et validation de données système internes',
      'Amélioration des workflows de traitement de données',
      'Collaboration inter-équipes pour cohérence des données',
    ],
  },
];

export const certifications = [
  { label: 'Oracle Certified Professional – Java SE 17 (2026)', color: 'accent' },
  { label: 'Oracle Cloud Infrastructure Foundations Associate (2025)', color: '' },
  { label: 'Data Visualization — Kaggle', color: '' },
  { label: 'C Essentials 1 — Cisco', color: '' },
];
